const moreBtns = document.querySelectorAll('.service-content__btn');

moreBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    const text = btn
      .closest('.service-content__inner')
      .querySelector('.service-content__text');
    text.classList.add('active');
    btn.style.display = 'none';
  });
});



// WEBPACK FOOTER //
// ./scripts/partials/showMore.js